:host {
  /**
   * @prop --tabs-dimension-panel-margin-top: Optional margin-top for panels
   */
  --tabs-dimension-panel-margin-top: var(--pine-dimension-none);
  /**
   * @prop --tabs-dimension-panel-padding: Optional padding for panels
   */
  --tabs-dimension-panel-padding: 0;

  display: block;
}

.pds-tabs__tablist {
  display: flex;
  flex-wrap: wrap;
  gap: var(--pine-dimension-md);
}

:host(.pds-tabs--availability) .pds-tabs__tablist {
  gap: var(--pine-dimension-xs);
}

:host(.pds-tabs--filter) .pds-tabs__tablist {
  gap: var(--pine-dimension-sm);
}

:host(.pds-tabs--pill) .pds-tabs__tablist {
  background-color: var(--pine-color-background-app);
  border: var(--pine-border-width-thin) solid var(--pine-color-border-subtle);
  border-radius: var(--pine-dimension-100);
  display: inline-flex;
  display: flex;
  gap: 0;
  height: var(--pine-dimension-450);
}
